// Build the natural offer label from a listing, using the current translations map.
// Never translates the brand name. Falls back to a generic "Vente" / "Location" when
// the category is not mapped.
import { translations } from "@/i18n/translations";

export const SPACE_CATEGORY_LABELS = {
  coworking: "Espace de coworking",
  bureau_prive: "Bureau privé",
  salle_reunion: "Salle de réunion",
  salle_conference: "Salle de conférence",
  salle_formation: "Salle de formation",
  salle_mariage: "Salle de mariage",
  salle_reception: "Salle de fête / réception",
  espace_exterieur: "Espace extérieur",
};

export function getPricePeriodLabel(period, lang = "fr") {
  const labels = lang === "en"
    ? { hour: "/ hour", day: "/ day", month: "/ month", year: "/ year", event: "/ event", week: "/ week" }
    : { hour: "/ heure", day: "/ jour", month: "/ mois", year: "/ an", event: "/ événement", week: "/ semaine" };
  return labels[period] || labels.month;
}

export function getOfferLabel(listing, lang = "fr") {
  if (!listing) return "";
  const purpose = listing.purpose === "rent" ? "rent" : "sale";
  const cat = (listing.category || "").toLowerCase();
  const map = translations[lang]?.offer?.[purpose] || {};
  if (map[cat]) return map[cat];
  const category = SPACE_CATEGORY_LABELS[cat];
  if (category) return `${purpose === "rent" ? (lang === "en" ? "Rental" : "Location") : (lang === "en" ? "Sale" : "Vente")} · ${category}`;
  return map._default;
}
